<div style="display:flex; position:absolute; top:0; left:0; right:0; bottom:0; justify-content:space-around;" id="canvas-holder">
    <div style="align-self:center; width:40%;"><img src="/assets/spinner.gif" style="width:100%;"/></div>
</div>
<div id="myPanoViewer"></div>
